import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import LinksPage from "./pages/LinksPage/LinksPage";
import Vote from "./pages/Vote/Vote";
import Header from "./components/Header/Header";
import "./App.css";

function App() {
    return (
        <div className="App">
            <HashRouter>
                <Header />
                <Routes>
                    <Route path="/" element={<LinksPage />} />
                    <Route path="/vote" element={<Vote />} />
                </Routes>
            </HashRouter>
        </div>
    );
}

export default App;
